import React from 'react'
import Link from 'gatsby-link'
import './Footer.css'

const Footer = () => (
  <div className="Footer w-100">
    <hr />
    <div className="Footer-container w-100 p-2">
      <div>
        <div className="d-inline-flex p-2 mb-3">
          <i className="fa fa-newspaper-o icon-logo" />
          <h5 className="p-0 ml-2 mb-0 l-h-36">DailyClouds</h5>
        </div>
      </div>
      <div>
        <h5 className="annie mb-0 grey">Connect with us</h5>
        <div className="mb-2">
          <a href="https://github.com/inmagik" target="_blank"><i className="fa fa-github fa-lg ml-2 mr-2 grey" /></a>
          <a href="https://twitter.com/inmagiklabs?lang=it" target="_blank"><i className="fa fa-twitter fa-lg ml-2 mr-2 grey" /></a>
          <a href="https://www.facebook.com/inmagik" target="_blank"><i className="fa fa-facebook fa-lg ml-2 mr-2 grey" /></a>
        </div>
      </div>
    </div>
    <div className="Footer-bottom">
      <span className="annie">© 2018 - <a href="https://inmagik.com/it/" className="footer-link-inmagik" target="_blank">INMAGIK</a></span>
    </div>
  </div>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/index.js